export const SigninWithOrganisationAccount = 'Sign-in with your organisation account'

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again later.'

export const DL_NUMBER_EMPTY_ERROR_MESSAGE = 'Please enter the driving license registration number.'

export const DOB_EMPTY_ERROR_MESSAGE = 'Please enter your date of birth.'

export const DIGILOCKER_KYC_FAIL_ERROR_MESSAGE =
  'We encountered an issue while validating your KYC information through Digilocker. Please try again later, or use another KYC method.'

export const INVALID_PAN_ERROR_PROMPT = 'Please enter a valid PAN number.'

export const INVALID_DATE_ERROR_PROMPT = 'Please enter a valid date.'

export const FILL_KYC_DETAILS_AND_SAVE_MESSAGE =
  'Please verify the PAN and complete the KYC of all the partners added'
